import gql from 'graphql-tag'

export const pendingApplicationsQuery = gql`
  query ($orderBy: ApplicationOrderByInput, $first: Int, $skip: Int) {
    pendingApplications(orderBy: $orderBy, first: $first, skip: $skip) {
      id
      name
      email
      createdAt
    }
  }
`

export const pendingApplicationsCountQuery = gql`{ pendingApplicationsCount }`

export const approvedApplicationsQuery = gql`
  query ($orderBy: ApplicationOrderByInput, $first: Int, $skip: Int) {
    approvedApplications(orderBy: $orderBy, first: $first, skip: $skip) {
      id
      name
      email
      createdAt
    }
  }
`

export const approvedApplicationsCountQuery = gql`{ approvedApplicationsCount }`

export const rejectedApplicationsQuery = gql`
  query ($orderBy: ApplicationOrderByInput, $first: Int, $skip: Int) {
    rejectedApplications(orderBy: $orderBy, first: $first, skip: $skip) {
      id
      name
      email
      createdAt
    }
  }
`

export const rejectedApplicationsCountQuery = gql`{ rejectedApplicationsCount }`

export const applicationQuery = gql`
  query ($id: ID!) {
    application(id: $id) {
      id
      createdAt
      updatedAt
      name
      email
      phone
      city
      state
      zipCode
      photo
      video
      instagram
      instagramFollowers
      certifications
      yearsOfExperience
      experience
      hourlyRate
      classes
      specialties
      bio
      source
      status
      approvedAt
      rejectedAt
      applicationNotes{
        id
        createdAt
        updatedAt
        note
        application{
          id
        }
        user{
          name
        }
      }
    }
  }
`

export const applicationNoteQuery = gql`
  query ($id: ID!) {
    applicationNote(id: $id) {
      id
      createdAt
      updatedAt
      application
      user{
        id
        name
      }
      note
    }
  }
`
export const createApplicationNoteMutation = gql`
  mutation($applicationId: ID!, $note: String!) {
    createApplicationNote(applicationId: $applicationId, note: $note) {
      note
      user{
        id
      }
    }
  }
`
export const approveApplicationMutation = gql`
  mutation ($id: ID!, $suppressEmail: Boolean) {
    approveApplication (id: $id, suppressEmail: $suppressEmail) {
      id
      email
    }
  }
`
export const rejectApplicationMutation = gql`
  mutation ($id: ID!, $suppressEmail: Boolean) {
    rejectApplication (id: $id, suppressEmail: $suppressEmail) {
      id
      email
    }
  }
`

export const unrejectApplicationMutation = gql`
  mutation ($id: ID!) {
    unrejectApplication (id: $id) {
      id
      email
    }
  }
`
